import initialState from './initialState'
import {
  INCOMING_SOCKET,
  NOTIFICATION,
  POPULATE,
  UPDATE,
  DISCONNECT_SOCKET,
  UPDATE_VOLUMEN_PAEZ
} from './typeMessages'

const trunk = x => x !== null ? Math.floor(x * 100) / 100 : null

const lastNullRemove = (data, n) => {
  if (data.slice(-1)[0][1] === null && n !== 0) {
    return lastNullRemove(data.slice(0, -1), n - 1)
  } else {
    return data
  }
}

const locationsReducer = (locations, payload, type) => {
  switch (type) {
    case INCOMING_SOCKET:
      if (!(payload.location in locations)) return locations
      if (!(payload.name in locations[payload.location].indicators)) return locations
      return {
        ...locations,
        [payload.location]: {
          indicators: {
            ...locations[payload.location].indicators,
            [payload.name]: {
              ...locations[payload.location].indicators[payload.name],
              lastUpdate: payload.data[0],
              lastValue: trunk(payload.data[1])
            }
          },
          lastUpdate: Date.now(),
          connect: true
        }
      }

    case POPULATE:
      if (!(payload.location in locations)) return locations
      if (!(payload.name in locations[payload.location].indicators)) return locations

      return {
        ...locations,
        [payload.location]: {
          ...locations[payload.location],
          indicators: {
            ...locations[payload.location].indicators,
            [payload.name]: {
              ...locations[payload.location].indicators[payload.name],
              data: lastNullRemove(payload.data, 3).map(e => [e[0], trunk(e[1])]),
              populated: true
            }
          }
        }
      }

    case UPDATE_VOLUMEN_PAEZ:
      if (!(payload.location in locations)) return locations
      if (!(payload.name in locations[payload.location].indicators)) return locations
      let lastValue = locations[payload.location].indicators[payload.name].data.pop()
      let e = lastNullRemove(payload.data.slice(0), 3).slice(-1)[0]
      let data = [
        ...locations[payload.location].indicators[payload.name].data
      ]

      if (lastValue[0] === e[0]) {
        console.log('not else')
        data = [ ...data,
          [e[0], trunk(e[1])]
        ]
      } else {
        console.log('else')
        data = [ ...data,
          lastValue,
          [e[0], trunk(e[1])]
        ]
      }

      return {
        ...locations,
        [payload.location]: {
          ...locations[payload.location],
          indicators: {
            ...locations[payload.location].indicators,
            [payload.name]: {
              ...locations[payload.location].indicators[payload.name],
              data: data,
              lastUpdate: e[0],
              lastValue: trunk(e[1])
            }
          }
        }
      }

    case UPDATE:
      if (!(payload.location in locations)) return locations
      if (!(payload.name in locations[payload.location].indicators)) return locations
      return {
        ...locations,
        [payload.location]: {
          ...locations[payload.location],
          indicators: {
            ...locations[payload.location].indicators,
            [payload.name]: {
              ...locations[payload.location].indicators[payload.name],
              data: [
                ...locations[payload.location].indicators[payload.name].data,
                ...lastNullRemove(payload.data.slice(1), 3).slice(-1).map(e => [e[0], trunk(e[1])])
              ]
            }
          }
        }
      }

    case DISCONNECT_SOCKET:
      if (!(payload.location in locations)) return locations
      return {
        ...locations,
        [payload.location]: {
          ...locations[payload.location],
          connect: false
        }
      }

    default:
      return locations
  }
}

const notificationsReducer = (notifications, payload, type) => {
  switch (type) {
    case NOTIFICATION:
      return [
        { ...payload },
        ...notifications
      ]
    default:
      return notifications
  }
}

export default function (state = initialState, { payload, type }) {
  return {
    locations: locationsReducer(state.locations, payload, type),
    notifications: notificationsReducer(state.notifications, payload, type)
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers.js